import { Component, OnInit } from '@angular/core';
import { faFacebook, faWeixin, faWhatsapp } from '@fortawesome/free-brands-svg-icons';
import { DeviceDetectorService } from 'ngx-device-detector';
import { DataService } from '../data.service';
import { SafeResourceUrl, DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-contact',
  templateUrl: './contact.component.html',
  styleUrls: ['./contact.component.scss']
})
export class ContactComponent implements OnInit {

  loaded: boolean;
  submitted: boolean = false;
  success:boolean = false;
  isDesktop: boolean = this.deviceService.isDesktop();
  mapUrl: SafeResourceUrl;
  formControls = this.data.messageForm.controls;

  contactData = {
    address: null,
    mapSearchTerm: '',
    shopTitle: null,
    whatsApp: ''
  };

  faFacebook = faFacebook;
  faWeixin = faWeixin;
  faWhatsapp = faWhatsapp;

  constructor(private deviceService: DeviceDetectorService, public data: DataService, private sanitizer: DomSanitizer) {

    data.getContactDB().subscribe(list => {
      list.forEach(item => {
        if(item.key === 'address'){
          this.contactData.address = item.payload.val();
        }
        else if(item.key === 'mapSearchTerm'){
          this.contactData.mapSearchTerm = item.payload.val();
        }
        else if(item.key === 'shopTitle'){
          this.contactData.shopTitle = item.payload.val();
        }
        else if(item.key === 'whatsApp'){
          this.contactData.whatsApp = item.payload.val();
        }
      })

      this.contactData.address = this.contactData.address.split('\n');
      this.contactData.shopTitle = this.contactData.shopTitle.split('\n');
      this.contactData.mapSearchTerm = this.contactData.mapSearchTerm.replace(/\s/g, '+');
      
      this.mapUrl = sanitizer.bypassSecurityTrustResourceUrl('https://www.google.com/maps/embed/v1/place?key=AIzaSyDxnLXkiOiK-14LOXkJNKzPYBtPR7sH9uE&q=' + this.contactData.mapSearchTerm);
      this.loaded = true;
    });
  }

  onSubmit() {
    this.submitted = true;

    if(this.data.messageForm.valid){
      this.success = true;
      setTimeout(()=>{this.success = false}, 3000);
      this.submitted = false;
      this.data.sendFeedback(this.data.messageForm.value);
    }
  }

  ngOnInit() {
  }

}
